import { useEffect, useRef } from "react";
import { transformEldml } from "./utils/eldmlTransformerUtils";
import { EldmlTransformerHelper } from "./eldmlTransform/EldmlTransformerHelper";
import React from "react";

export interface ViewerProps {
  content: string;
  eldmlTransformer: EldmlTransformerHelper;
}

export const Viewer = (props: ViewerProps) => {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if(rootRef.current) {
      transformEldml(rootRef.current, props.eldmlTransformer);
    }
  }, []);

  return (
    <div
      ref={rootRef}
      dangerouslySetInnerHTML={{ __html: props.content }}
    ></div>
  );
}
